import { defineStore } from "pinia";

export const useDebugErrorStore = defineStore("debugError", {
  state: () => ({
    visible: false,
    text: "",
    title: "Error (depuración)",
  }),
  actions: {
    showError(text, title) {
      this.text = String(text);
      this.title = title || "Error (depuración)";
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.text = "";
    },
    async copyToClipboard() {
      const t = this.text;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(t);
          return true;
        }
      } catch {
        /* fallback abajo */
      }
      try {
        const ta = document.createElement("textarea");
        ta.value = t;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        return ok;
      } catch {
        return false;
      }
    },
  },
});
